import { render, staticRenderFns } from "./AssetAttachmentList.vue?vue&type=template&id=2c00efd8&scoped=true&"
import script from "./AssetAttachmentList.vue?vue&type=script&lang=js&"
export * from "./AssetAttachmentList.vue?vue&type=script&lang=js&"
import style0 from "./AssetAttachmentList.vue?vue&type=style&index=0&id=2c00efd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00efd8",
  null
  
)

export default component.exports